module.exports = __webpack_public_path__ + "static/img/push.38c7bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/push.png
// module id = pOap
// module chunks = 69